const m = require('minthril');
const { component } = require('../../component');

function openCheckout() {
  const transactionId = new URLSearchParams(window.location.search).get('_ptxn');
  const token = document.querySelector('meta[name="paddle-client-token"]')?.content;

  if (!transactionId || !window.Paddle || !token || token === '__PADDLE_CLIENT_TOKEN__') {
    return;
  }

  window.Paddle.Environment.set('sandbox');
  window.Paddle.Initialize({ token });
  window.Paddle.Checkout.open({
    transactionId,
    settings: {
      displayMode: 'inline',
      frameTarget: 'pay-checkout',
      frameInitialHeight: '600',
      frameStyle: 'width: 100%; min-width: 312px; background-color: transparent; border: none;'
    }
  });
}

const PayPage = component(() => {
  return {
    view: () => m('section.panel.pay-page', { oncreate: openCheckout }, [
      m('h2', 'Complete your Spache payment'),
      m('p', 'Your Paddle checkout is loading. If it does not appear, refresh this page or return to billing.'),
      m('div.pay-checkout'),
      m('a.button.button--quiet', { href: '/account/billing' }, 'Return to billing')
    ])
  };
});

module.exports = { PayPage };
